export const defaultPath = 'viromeatlas/ncbi/viruses/ncbi_viruses_genbank_seq_pub_01022026.parquet.gzip';
export const animathonPath = 'viromeatlas/hackathon/animathon/taxonomy_occurences-biosample_org_meta.parquet.gzip';
export const fullPath = 'viromeatlas/V@_full_dataset_26022026.parquet';
export const fullPathwithBiomes = 'viromeatlas/V@_full_dataset_geom@nnoted_20260313.parquet.gzip';
//export const shuffledFullPath = 'viromeatlas/tmp/V@_full_dataset_geom@nnoted_20260313_shuffled.parquet.gzip';
export const shuffledFullPath = 'viromeatlas/V@_dataset_latest_shuffle.parquet';
//export const shuffledFullPath = 'viromeatlas-dev/dev/V@_dataset_latest_shuffled.parquet';
//export const shuffledreducedPath = 'viromeatlas/tmp/V@_dataset_latest_shuffle.parquet';
export const statPath = 'viromeatlas/V@_biosample_sra_stat_organism_groups.parquet';
export const STAT_TABLE_PATH = 'https://biosphere-s3.france-bioinformatique.fr/viromeatlas/sra-virome.parquet';
export const geometryPath1 = '/viromeatlas/webtool_table/V@_dataset_minimap.parquet';
export const geometryPath2 = 'viromeatlas/webtool_table/minimap_original_geom_unique.parquet';
export const enrichedPath = 'viromeatlas/hackathon/writeathon/summary_table.parquet';
//export const GEOM_TABLE_PATH = 'viromeatlas/geom@nnot_latest.parquet';
export const GEOM_TABLE_PATH = 'viromeatlas-dev/dev/geomannot.parquet';
export const BIOMES_PATH = 'https://biosphere-s3.france-bioinformatique.fr/viromeatlas/tmp/biomes_cut.geojson';
export const ECOREGIONS_PATH = 'https://biosphere-s3.france-bioinformatique.fr/viromeatlas/tmp/ecoregions_cut.geojson';
export const goldenAngle = 137.5077640500378;
export const equatorialCircumference = 40075017; // meters
export const yearInMs = 365 * 24 * 60 * 60 * 1000; // milliseconds in a year
export const PIXEL_SPREAD = 20;
export const SITE_PASSWORD = 'Trojan_horse37866';
export const GRID_COLS = 12;


export  const TAB_CONFIG = {
    "host":["HOST_TAX_NAME",'HOST_SPECIES', 'HOST_GENUS', 'HOST_FAMILY',
         'HOST_ORDER', 'HOST_CLASS', 'HOST_PHYLUM', 'HOST_KINGDOM',
         'HOST_SUPERKINGDOM', 'HOST_ORGANISM_GROUP', 'HOST_COMMON_NAME'],
    "virus":["VIRUS_TAX_NAME",'VIRUS_SPECIES',
         'VIRUS_GENUS', 'VIRUS_FAMILY', 'VIRUS_ORDER', 'VIRUS_CLASS',
         'VIRUS_PHYLUM', 'VIRUS_KINGDOM', 'VIRUS_SUPERKINGDOM'],
    "matrix": ["MATRIX", "UBERON_LABEL"],
    "environment": ["ENVIRONMENT_TAX_NAME","ENVO_LABEL"],   
    "location":["COUNTRY_NAME","COUNTRY", "FIRST_ADMIN_SUBDIVISION_NAME","CONTINENT","geotagged_location","display_name","unique_locations"],
    "disease": ["MONDO_LABEL"],
  };

export const ICON_MAPPING = {
  sample_type: {
    'organism metagenome': { color: '#f43f5e', path: "M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z" },
    'organism': { color: '#22c55e', path: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" },
    'environmental metagenome': { color: '#3b82f6', path: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" },
    'viral metagenome': { color: '#f97316', path: "M12 7v5l3 3M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" },
    'viral sequence': { color: '#a855f7', path: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" },
  },
  sample_category: {
    'host-associated': { color: '#8511a9', path: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" },
    'environmental': { color: '#22c55e', path: "M12 22v-5M9 17l3 3 3-3M8 12l4-4 4 4M12 8V3" },
    'Undetermined': { color: '#3b82f6', path: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-15v6m0 4h.01" },
  },
  source: {
    'NCBI BioSample': { color: '#e8871f', path: "M3 21h18M3 10h18M5 6l7-3 7 3M4 10v11M20 10v11" }, // Institution/Bank
    'Viral Genbank': { color: '#22c55e', path: "M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" }, // Strand/DNA
    'GSA BioSample': { color: '#3b82f6', path: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" } // Data profile
  },
  COORDINATES_ORIGINS: {
    'coordinates_parsing': { color: '#1d2cb1', path: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" }, // Pin
    'geoparsing': { color: '#22c55e', path: "M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z" } // Map
  },
  'Land|Ocean': {
    'Land': { 
    color: '#92400e', 
    path: "M2 15l4-10 8 14M12 15l4-7 5 7" 
  },
    'Ocean': { color: '#15a8bb', path: "M2 6c1.5 0 2.5 1 4 1s2.5-1 4-1 2.5 1 4 1 2.5-1 4-1M2 12c1.5 0 2.5 1 4 1s2.5-1 4-1 2.5 1 4 1 2.5-1 4-1" } // Waves
  },
  HOST_SEX: {
    'Male': { 
      color: '#3b82f6', 
      path: "M21 3h-6M21 3v6M21 3l-6 6M12 8a5 5 0 1 0 0 10 5 5 0 0 0 0-10z" 
    },
    'Female': { 
      color: '#ec4899', 
      path: "M12 14v7M9 18h6M12 13a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" 
    },
    'Neuter': { 
      color: '#94a3b8', 
      path: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM5 12h14" 
    },
    'Both/Mixed': { 
      color: '#a855f7', 
      path: "M13 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM13 13v5M9 16h8M17 5l4-4M20 1h-4M21 2v4" 
    },
    'Intersex': { 
      color: '#eab308', 
      path: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0 M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" 
    },
  },
   MATRIX: {
    // Digestive/Clinical (Reds/Pinks)
    'digestive': { color: '#fb7185', path: "M12 3c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM12 15c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z" },
    'feces': { color: '#92400e', path: "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" },
    'respiratory': { color: '#f472b6', path: "M20.39 18.39A5 5 0 0 0 18 10h-1.26A8 8 0 1 0 3 16.3" },
    'clinical': { color: '#ef4444', path: "M12 5v14M5 12h14" },
    'blood': { color: '#cf2121', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'organ': { color: '#dc2626', path: "M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM12 13v8" },
    'skin': { 
    color: '#fda4af', 
    path: "M4 8c8-2 12-2 16 0M4 12c8-2 12-2 16 0M4 16c8-2 12-2 16 0" 
    },
    'vagina': { color: '#db2777', path: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z" },
    'reproductive tract': { color: '#ec4899', path: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" },
    'urine': { color: '#eab308', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'other biofluid': { color: '#d946ef', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    
    // Environment/Nature (Greens/Earth)
    'soil': { color: '#451a03', path: "M2 17h20M2 12h20M2 7h20" },
    'plant': { color: '#16a34a', path: "M2 22c0-5.5 4.5-10 10-10 5.5 0 10 4.5 10 10M12 2v10" },
    'sediment': { color: '#713f12', path: "M2 17h20M2 12h20M2 7h20" },
    'cell': { color: '#0d9488', path: "M12 3l8.66 5v10L12 21l-8.66-5V8z" },
    'air': { color: '#94a3b8', path: "M5 12h14M8 17h8M10 7h4" },

    // Water/Aqueous (Blues)
    'freshwater': { color: '#60a5fa', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'water': { color: '#0ea5e9', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'seawater': { color: '#1d4ed8', path: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" },
    'wastewater': { color: '#475569', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
  },
  ENVO_LABEL: {
    // Water & Aquatic (Blues)
    'sterile water': { color: '#0ea5e9', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'lake': { color: '#0ea5e9', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'lake water': { color: '#0ea5e9', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'spring water': { color: '#48bcf1', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'pond': { color: '#0ea5e9', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'freshwater lake': { color: '#60a5fa', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'river': { color: '#3b82f6', path: "M2 6c1.5 0 2.5 1 4 1s2.5-1 4-1 2.5 1 4 1 2.5-1 4-1M2 12c1.5 0 2.5 1 4 1s2.5-1 4-1 2.5 1 4 1 2.5-1 4-1" },
    'stream': { color: '#3b82f6', path: "M2 6c1.5 0 2.5 1 4 1s2.5-1 4-1" },
    'watercourse': { color: '#3b82f6', path: "M2 12c1.5 0 2.5 1 4 1s2.5-1 4-1 2.5 1 4 1 2.5-1 4-1" },
    'ocean': { color: '#0c35a3', path: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" },
    'sea': { color: '#2050d4', path: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" },
    'marine biome': { color: '#1d4ed8', path: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z" },
    'aquatic biome': { color: '#0284c7', path: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z" },
    'estuary': { color: '#0284c7', path: "M2 12h20M2 7c1.5 0 2.5 1 4 1" },
    'groundwater': { color: '#1e40af', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5" },
    'polar': { 
        color: '#a5f3fc', 
        path: "M3 20c0-10 4-14 9-14s9 4 9 14H3z" 
    },
    // Forest, Plants & Nature (Greens)
    'forested area': { color: '#16a34a', path: "M12 22v-5M9 17l3 3 3-3M8 12l4-4 4 4M12 8V3" },
    'forest biome': { color: '#16a34a', path: "M12 22v-5M9 17l3 3 3-3M8 12l4-4 4 4" },
    'temperate forest': { color: '#15803d', path: "M12 22v-5M9 17l3 3 3-3M8 12l4-4 4 4" },
    'woodland area': { color: '#166534', path: "M12 22v-5M9 17l3 3 3-3M8 12l4-4 4 4" },
    'terrestrial biome': { color: '#15803d', path: "M12 22v-5M9 17l3 3 3-3" },
    'rhizosphere': { color: '#4d7c0f', path: "M12 12c-3.3 0-6 2.7-6 6h12c0-3.3-2.7-6-6-6zM12 2v10" },
    'plant matter': { color: '#16a34a', path: "M12 2v10M2 22c0-5.5 4.5-10 10-10 5.5 0 10 4.5 10 10" },
    'garden': { color: '#22c55e', path: "M12 22v-5M9 17l3 3 3-3M8 12l4-4 4 4" },
    'grassland soil': { color: '#18af2c', path: "M2 12h20M2 17h20" },

    // Soil, Field & Sediment (Browns/Earth)
    'mountain': { color: '#603a05', path: "M2 15l4-10 8 14M12 15l4-7 5 7" },
    'field': { color: '#a16207', path: "M3 9h18M3 15h18M9 3v18M15 3v18" },
    'agricultural field': { color: '#a16207', path: "M3 9h18M3 15h18M9 3v18M15 3v18" },
    'agricultural soil': { color: '#a16207', path: "M3 9h18M3 15h18M9 3v18M15 3v18" },
    'farm': { color: '#84cc16', path: "M3 9h18M3 15h18M9 3v18M15 3v18" },
    'soils': { color: '#854d0e', path: "M11 20A7 7 0 0 1 4 13c0-4.5 7-11 7-11s7 6.5 7 11a7 7 0 0 1-7 7z" },
    'bulk soil': { color: '#713f12', path: "M11 20A7 7 0 0 1 4 13c0-4.5 7-11 7-11s7 6.5 7 11a7 7 0 0 1-7 7z" },
    'marine sediment': { color: '#451a03', path: "M2 17h20M2 12h20M2 7h20" },
    'peatland': { color: '#78350f', path: "M2 17h20M2 12h20M2 7h20" },
    'marsh': { color: '#1e3a8a', path: "M2 12h20M2 17h20" },
    'forest soil': { color: '#116d1e', path: "M2 12h20M2 17h20" },
    'clay soil': { color: '#af4318', path: "M2 12h20M2 17h20" },

    // Human & Urban Environments (Slate/Rose)
    'urban biome': { color: '#475569', path: "M2 22h20M7 22v-5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v5" },
    'hospital': { color: '#ef4444', path: "M12 2v20M5 12h14" },
    'fecal materials': { color: '#92400e', path: "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" },
    'digestive tract environment': { color: '#fb7185', path: "M12 3c-4.4 0-8 3.6-8 8s3.6 8 8 8" },
    'intestine environment': { color: '#fb7185', path: "M12 3c-4.4 0-8 3.6-8 8s3.6 8 8 8" },
    'activated sludge': { color: '#475569', path: "M12 2v20M5 12h14" },
    'bioreactor': { color: '#64748b', path: "M12 2v20M5 12h14M8 12l4-4 4 4" },
    'biofilm': { color: '#ec4899', path: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z" },

    // Other
    'fire': { 
    color: '#ef4444', 
    path: "M12 3v18M8 8v13M16 8v13" 
    },
    'blood': { color: '#ef4444', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'plasma': { color: '#ef4444', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
  },
  MONDO_LABEL: {
    // -----------------------------------------------------
    // Respiratory & Viral/Bacterial Infectious Diseases
    // -----------------------------------------------------
    'COVID-19': { color: '#dc2626', path: "M12 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12zM12 2v4M12 18v4M2 12h4M18 12h4M5 5l3 3M16 16l3 3M5 19l3-3M16 5l-3 3" },
    'COVID-19S': { color: '#dc2626', path: "M12 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12zM12 2v4M12 18v4M2 12h4M18 12h4M5 5l3 3M16 16l3 3M5 19l3-3M16 5l-3 3" },
    'severe acute respiratory syndrome': { color: '#be123c', path: "M12 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12zM12 2v4M12 18v4M2 12h4M18 12h4M5 5l3 3M16 16l3 3M5 19l3-3M16 5l-3 3" },
    'influenza': { color: '#06b6d4', path: "M12 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12zM12 2v4M12 18v4M2 12h4M18 12h4M5 5l3 3M16 16l3 3M5 19l3-3M16 5l-3 3" },
    
    'tuberculosis': { color: '#0d9488', path: "M5.5 8.5C3 8.5 2 11 2 14c0 4 3.5 7 5.5 7s2.5-1 2.5-3v-7c0-1.5-2-2.5-4.5-2.5zm13 0c-2.5 0-4.5 1-4.5 2.5v7c0 2 1.5 3 2.5 3S22 18 22 14c0-3-1-5.5-3.5-5.5zM12 2v6M12 8l-2 2M12 8l2 2" },
    'pulmonary tuberculosis': { color: '#14b8a6', path: "M5.5 8.5C3 8.5 2 11 2 14c0 4 3.5 7 5.5 7s2.5-1 2.5-3v-7c0-1.5-2-2.5-4.5-2.5zm13 0c-2.5 0-4.5 1-4.5 2.5v7c0 2 1.5 3 2.5 3S22 18 22 14c0-3-1-5.5-3.5-5.5zM12 2v6M12 8l-2 2M12 8l2 2" },
    'pneumonia': { color: '#3b82f6', path: "M5.5 8.5C3 8.5 2 11 2 14c0 4 3.5 7 5.5 7s2.5-1 2.5-3v-7c0-1.5-2-2.5-4.5-2.5zm13 0c-2.5 0-4.5 1-4.5 2.5v7c0 2 1.5 3 2.5 3S22 18 22 14c0-3-1-5.5-3.5-5.5zM12 2v6M12 8l-2 2M12 8l2 2" },
    'asthma': { color: '#0ea5e9', path: "M5.5 8.5C3 8.5 2 11 2 14c0 4 3.5 7 5.5 7s2.5-1 2.5-3v-7c0-1.5-2-2.5-4.5-2.5zm13 0c-2.5 0-4.5 1-4.5 2.5v7c0 2 1.5 3 2.5 3S22 18 22 14c0-3-1-5.5-3.5-5.5zM12 2v6M12 8l-2 2M12 8l2 2" },
    'cystic fibrosis': { color: '#94a3b8', path: "M5.5 8.5C3 8.5 2 11 2 14c0 4 3.5 7 5.5 7s2.5-1 2.5-3v-7c0-1.5-2-2.5-4.5-2.5zm13 0c-2.5 0-4.5 1-4.5 2.5v7c0 2 1.5 3 2.5 3S22 18 22 14c0-3-1-5.5-3.5-5.5zM12 2v6M12 8l-2 2M12 8l2 2" },
    'lung adenocarcinoma': { color: '#581c87', path: "M5.5 8.5C3 8.5 2 11 2 14c0 4 3.5 7 5.5 7s2.5-1 2.5-3v-7c0-1.5-2-2.5-4.5-2.5zm13 0c-2.5 0-4.5 1-4.5 2.5v7c0 2 1.5 3 2.5 3S22 18 22 14c0-3-1-5.5-3.5-5.5zM12 2v6M12 8l-2 2M12 8l2 2" },

    'infectious disease': { color: '#f97316', path: "M7 4h10a5 5 0 0 1 5 5v6a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5z M6 4v16 M18 4v16 M12 4v16 M2 12h20" },
    'gonorrhea': { color: '#f59e0b', path: "M7 4h10a5 5 0 0 1 5 5v6a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5z M6 4v16 M18 4v16 M12 4v16 M2 12h20" },
    
    // -----------------------------------------------------
    // Cancers & Neoplasms (Clustered cells / Tumors)
    // -----------------------------------------------------
    'neoplasm': { color: '#9333ea', path: "M10 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-2 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm6 0a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0z" },
    'cancer': { color: '#a855f7', path: "M10 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-2 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm6 0a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0z" },
    'carcinoma': { color: '#6d28d9', path: "M10 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-2 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm6 0a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0z" },
    'adenocarcinoma': { color: '#c026d3', path: "M10 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-2 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm6 0a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0z" },
    'prostate cancer': { color: '#7c3aed', path: "M10 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-2 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm6 0a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0z" },
    'breast neoplasm': { color: '#ec4899', path: "M10 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-2 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm6 0a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0z" },
    'breast cancer': { color: '#db2777', path: "M10 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-2 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm6 0a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0z" },
    'melanoma': { color: '#451a03', path: "M10 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-2 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm6 0a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0z" },

    // -----------------------------------------------------
    // Gastrointestinal & Liver
    // -----------------------------------------------------
    'gastroenteritis': { color: '#ea580c', path: "M6 18V9c0-3 2-4 4-4h4c2 0 4 1 4 4v9 M10 18v-5c0-1 1-2 2-2s2 1 2 2v5" },
    'Salmonella gastroenteritis': { color: '#ca8a04', path: "M6 18V9c0-3 2-4 4-4h4c2 0 4 1 4 4v9 M10 18v-5c0-1 1-2 2-2s2 1 2 2v5" },
    'diarrheal disease': { color: '#a16207', path: "M6 18V9c0-3 2-4 4-4h4c2 0 4 1 4 4v9 M10 18v-5c0-1 1-2 2-2s2 1 2 2v5" },
    'colorectal cancer': { color: '#d946ef', path: "M6 18V9c0-3 2-4 4-4h4c2 0 4 1 4 4v9 M10 18v-5c0-1 1-2 2-2s2 1 2 2v5" },
    'colorectal neoplasm': { color: '#8b5cf6', path: "M6 18V9c0-3 2-4 4-4h4c2 0 4 1 4 4v9 M10 18v-5c0-1 1-2 2-2s2 1 2 2v5" },
    'inflammatory bowel disease': { color: '#dc2626', path: "M6 18V9c0-3 2-4 4-4h4c2 0 4 1 4 4v9 M10 18v-5c0-1 1-2 2-2s2 1 2 2v5" },
    'Clostridium difficile colitis': { color: '#84cc16', path: "M6 18V9c0-3 2-4 4-4h4c2 0 4 1 4 4v9 M10 18v-5c0-1 1-2 2-2s2 1 2 2v5" },
    'hepatitis': { color: '#b45309', path: "M20 9c-1-3-5-4-9-4-5 0-8 2-8 5 0 2 2 4 4 5 3 2 7 2 10 0 2-1 4-4 3-6z M12 14v6 M15 12v5" },
    'hepatocellular carcinoma': { color: '#7e22ce', path: "M20 9c-1-3-5-4-9-4-5 0-8 2-8 5 0 2 2 4 4 5 3 2 7 2 10 0 2-1 4-4 3-6z M12 14v6 M15 12v5" },

    // -----------------------------------------------------
    // Neurological & Brain
    // -----------------------------------------------------
    'Alzheimer disease': { color: '#2563eb', path: "M12 4.5C7 4.5 4 7 4 10.5c0 1.5.5 2.5 1 3.5.5 1 .5 2 0 3-1.5 2-1 3 1 3h12c2 0 2.5-1 1-3-.5-1-.5-2 0-3 .5-1 1-2 1-3.5 0-3.5-3-6-7-6zM12 5v15" },
    'schizophrenia': { color: '#f472b6', path: "M12 4.5C7 4.5 4 7 4 10.5c0 1.5.5 2.5 1 3.5.5 1 .5 2 0 3-1.5 2-1 3 1 3h12c2 0 2.5-1 1-3-.5-1-.5-2 0-3 .5-1 1-2 1-3.5 0-3.5-3-6-7-6zM12 5v15" },
    'epilepsy': { color: '#8b5cf6', path: "M12 4.5C7 4.5 4 7 4 10.5c0 1.5.5 2.5 1 3.5.5 1 .5 2 0 3-1.5 2-1 3 1 3h12c2 0 2.5-1 1-3-.5-1-.5-2 0-3 .5-1 1-2 1-3.5 0-3.5-3-6-7-6zM12 5v15" },
    'Lewy body dementia': { color: '#4f46e5', path: "M12 4.5C7 4.5 4 7 4 10.5c0 1.5.5 2.5 1 3.5.5 1 .5 2 0 3-1.5 2-1 3 1 3h12c2 0 2.5-1 1-3-.5-1-.5-2 0-3 .5-1 1-2 1-3.5 0-3.5-3-6-7-6zM12 5v15" },

    // -----------------------------------------------------
    // Blood, Vascular, & Sepsis
    // -----------------------------------------------------
    'type 2 diabetes mellitus': { color: '#0ea5e9', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'plasma cell myeloma': { color: '#991b1b', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'acute myeloid leukemia': { color: '#be185d', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'leukemia': { color: '#f43f5e', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'bacterial infectious disease with sepsis': { color: '#7f1d1d', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'coronary artery disorder': { color: '#ef4444', path: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" },

    // -----------------------------------------------------
    // Autoimmune, Skeletal & Urinary
    // -----------------------------------------------------
    'systemic lupus erythematosus': { color: '#e11d48', path: "M12 12c-2-2-4-4-8-4-1 0-2 1.5-2 3 0 3 4 5 10 9 6-4 10-6 10-9 0-1.5-1-3-2-3-4 0-6 2-8 4z M12 2v10" },
    'arthritic joint disease': { color: '#ef4444', path: "M17 6c1 0 2 1 2 2s-1 2-2 2v4c1 0 2 1 2 2s-1 2-2 2-2-1-2-2h-6c0 1-1 2-2 2s-2-1-2-2 1-2 2-2v-4c-1 0-2-1-2-2s1-2 2-2 2 1 2 2h6c0-1 1-2 2-2z" },
    'urinary tract infection': { color: '#eab308', path: "M7 8c-2 0-4 2-4 5s2 5 4 5 3-1 4-3-1-4-1-5-1-2-3-2zm10 0c-2 0-4 2-4 5s2 5 4 5 3-1 4-3-1-4-1-5-1-2-3-2zM12 22v-6" },

    // -----------------------------------------------------
    // General, Genetics, & Others
    // -----------------------------------------------------
    'disease': { color: '#64748b', path: "M10 3h4v6h6v4h-6v6h-4v-6H4V9h6V3z" },
    'inherited disease susceptibility': { color: '#4338ca', path: "M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" },
    'malaria': { color: '#65a30d', path: "M8 10h8 M8 14h8 M12 4v4 M6 8l2 2 M18 8l-2 2 M6 16l2-2 M18 16l-2-2 M12 20a4 4 0 0 0-4-4V8a4 4 0 0 1 8 0v8a4 4 0 0 0-4 4z" },
  },
  UBERON_LABEL: {
    // Digestive System (Rose/Red)
    'digestive tract': { color: '#f43f5e', path: "M12 3c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM12 15c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z" },
    'intestine': { color: '#fb7185', path: "M12 3c-4.4 0-8 3.6-8 8s3.6 8 8 8" },
    'small intestine': { color: '#fb7185', path: "M12 3c-4.4 0-8 3.6-8 8s3.6 8 8 8" },
    'large intestine': { color: '#fb7185', path: "M12 3c-4.4 0-8 3.6-8 8s3.6 8 8 8" },
    'colon': { color: '#fb7185', path: "M12 3c-4.4 0-8 3.6-8 8s3.6 8 8 8" },
    'caecum': { color: '#fda4af', path: "M12 3c-4.4 0-8 3.6-8 8s3.6 8 8 8" },
    'rumen': { color: '#fda4af', path: "M12 3c-4.4 0-8 3.6-8 8s3.6 8 8 8" },
    'stomach': { color: '#e11d48', path: "M12 3c-4.4 0-8 3.6-8 8s3.6 8 8 8" },
    'liver': { color: '#991b1b', path: "M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM12 13v8" },
    'oral cavity': { color: '#fb7185', path: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z" },
    'mouth': { color: '#fb7185', path: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z" },

    // Respiratory System (Pink/Purple)
    'lung': { color: '#ec4899', path: "M20.39 18.39A5 5 0 0 0 18 10h-1.26A8 8 0 1 0 3 16.3" },
    'respiratory tract': { color: '#f472b6', path: "M20.39 18.39A5 5 0 0 0 18 10h-1.26A8 8 0 1 0 3 16.3" },
    'nasopharynx': { color: '#db2777', path: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z" },
    'throat': { color: '#db2777', path: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z" },

    // Biofluids & Secretions (Gold/Purple/Blue)
    'blood plasma': { color: '#ef4444', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'saliva': { color: '#a855f7', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5" },
    'milk': { color: '#eab308', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5" },
    'sputum': { color: '#8b5cf6', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5" },
    'mucus': { color: '#10b981', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5" },
    'vaginal fluid': { color: '#d946ef', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5" },
    'cerebrospinal fluid': { color: '#3b82f6', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5" },

    // Appendages & Skeletal (Slate/Stone)
    'head': { color: '#64748b', path: "M12 3a7 7 0 0 0-7 7c0 3 2 6 2 8v3h10v-3c0-2 2-5 2-8a7 7 0 0 0-7-7z M9 12h.01 M15 12h.01" },
    'leg': { color: '#cb99b3', path: "M10 2v14a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2 2 2 0 0 0-2-2h-2v-4a4 4 0 0 0 4-4V2" },
    'tail': { color: '#68101dd7', path: "M9 15a6 6 0 1 0 12-6 4 4 0 1 0-8 4 2 2 0 1 0 4-2" },
    'fin': { color: '#3b82f6', path: "M4 20h16C16 12 14 4 10 4 10 12 8 16 4 20z" },
    'skin of face': { color: '#fda4af', path: "M14 2c-3 0-5 2-5 5v2L6 11v2l2 1v2l-1 2a3 3 0 0 0 3 4h4" },
    'ear': { color: '#64748b', path: "M14 2c-6 0-9 4-9 10 0 1 1 2 1 3s-1 2-1 3c0 4 3 4 7 4 4 0 7-6 7-11S18 2 14 2z M14 7c-4 2-5 5-5 8 0 2 2 3 4 3 M11 12h2" },

    // Misc/Developmental
    'female organism': { color: '#ec4899', path: "M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 13v9M9 18h6" },
    'renal system': { color: '#7f1d1d', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5" },
    'gill': { 
    color: '#fb7185', 
    path: "M9 5c-3 4-3 10 0 14M13 5c-3 4-3 10 0 14M17 5c-3 4-3 10 0 14" 
    },
    'gill filament': { 
    color: '#fb7185', 
    path: "M9 5c-3 4-3 10 0 14M13 5c-3 4-3 10 0 14M17 5c-3 4-3 10 0 14" 
    },
  },
  ENVIRONMENT_TAX_NAME: {
    // Soil & Terrestrial (Browns/Earth)
    'soil metagenome': { color: '#854d0e', path: "M11 20A7 7 0 0 1 4 13c0-4.5 7-11 7-11s7 6.5 7 11a7 7 0 0 1-7 7z" },
    'terrestrial metagenome': { color: '#15803d', path: "M12 22v-5M9 17l3 3 3-3" },
    'sediment metagenome': { color: '#713f12', path: "M2 17h20M2 12h20M2 7h20" },
    'rhizosphere metagenome': { color: '#4d7c0f', path: "M12 12c-3.3 0-6 2.7-6 6h12c0-3.3-2.7-6-6-6zM12 2v10" },
    'root associated fungus metagenome': { color: '#65a30d', path: "M12 12c-3.3 0-6 2.7-6 6h12c0-3.3-2.7-6-6-6zM12 2v10" },
    'leaf litter metagenome': { color: '#a16207', path: "M11 20s-6-2-6-8 4-9 6-9 6 3 6 9-6 8-6 8z M11 3v17 M7 8l4 2 M15 11l-4 2" },
    'compost metagenome': { color: '#451a03', path: "M11 20A7 7 0 0 1 4 13c0-4.5 7-11 7-11s7 6.5 7 11a7 7 0 0 1-7 7z" },
    'peat metagenome': { color: '#431407', path: "M2 17h20M2 12h20M2 7h20" },

    // Marine & Aquatic (Blues)
    'marine metagenome': { color: '#1d4ed8', path: "M2 6c1.5 0 2.5 1 4 1s2.5-1 4-1 2.5 1 4 1 2.5-1 4-1M2 12c1.5 0 2.5 1 4 1s2.5-1 4-1 2.5 1 4 1 2.5-1 4-1" },
    'seawater metagenome': { color: '#1e40af', path: "M2 6c1.5 0 2.5 1 4 1s2.5-1 4-1 2.5 1 4 1 2.5-1 4-1M2 12c1.5 0 2.5 1 4 1s2.5-1 4-1 2.5 1 4 1 2.5-1 4-1" },
    'marine sediment metagenome': { color: '#1e3a8a', path: "M2 17h20M2 12h20" },
    'aquatic metagenome': { color: '#0ea5e9', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5c-.5 1-2 3.4-4 5s-3 3.5-3 5.5a7 7 0 0 0 7 7z" },
    'freshwater metagenome': { color: '#60a5fa', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5" },
    'lake water metagenome': { color: '#3b82f6', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5" },
    'estuary metagenome': { color: '#0284c7', path: "M2 12h20M2 7c1.5 0 2.5 1 4 1" },
    'coral reef metagenome': { color: '#06b6d4', path: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z" },
    'glacier metagenome': { color: '#bae6fd', path: "M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z" },

    // Clinical, Food & Industrial (Red/Orange/Slate)
    'clinical metagenome': { color: '#ef4444', path: "M12 5v14M5 12h14" },
    'hospital metagenome': { color: '#dc2626', path: "M12 2v20M5 12h14" },
    'food metagenome': { color: '#f59e0b', path: "M12 3c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z" },
    'food fermentation metagenome': { color: '#d97706', path: "M12 3c-4.4 0-8 3.6-8 8s3.6 8 8 8" },
    'bioreactor metagenome': { color: '#475569', path: "M12 2v20M5 12h14M8 12l4-4 4 4" },
    'wastewater metagenome': { color: '#64748b', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-5" },
    'activated sludge metagenome': { color: '#334155', path: "M12 5v14M5 12h14" },
    'indoor metagenome': { color: '#94a3b8', path: "M2 22h20M7 22v-5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v5" },
    'air metagenome': { color: '#cbd5e1', path: "M5 12h14M8 17h8M10 7h4" },

    // Specialized (Green/Teal/Pink)
    'biofilm metagenome': { color: '#db2777', path: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z" },
    'wetland metagenome': { color: '#15803d', path: "M2 12h20M2 17h20" },
    'rice paddy metagenome': { color: '#16a34a', path: "M2 22c0-5.5 4.5-10 10-10 5.5 0 10 4.5 10 10" },
    'microbial mat metagenome': { color: '#059669', path: "M2 17h20M2 12h20M2 7h20" },
    'milk metagenome': { color: '#facc15', path: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5" },
  },
  librarysource: {
    'VIRAL RNA': { 
      color: '#e11d48', // Rose 600
      path: "M16 2c-10 3-10 8-4 10 6 2 6 7-4 10 M12.8 6.5h3.5 M12.8 9.5h3.5 M7.5 14.5h3.5 M7.5 17.5h3.5"
    },
    'GENOMIC': { 
      color: '#4f46e5', // Indigo 600
      path: "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0 M15 12h6 M3 12h6 M12 3v6 M12 15v6" // DNA/Node symbol
    },
    'METAGENOMIC': { 
      color: '#0891b2', // Cyan 600
      path: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 16a8 8 0 1 1 8-8 8 8 0 0 1-8 8z M12 2" // Community/Mixed circles
    },
    'TRANSCRIPTOMIC': { 
      color: '#9333ea', // Purple 600
      path: "M3 3v18h18 M7 16v-4 M11 16V8 M15 16v-6 M19 16V4" // Bar chart (Expression levels)
    },
    'TRANSCRIPTOMIC SINGLE CELL': { 
      color: '#db2777', // Pink 600
      path: "M12 3L4.5 7.5v9l7.5 4.5 7.5-4.5v-9z M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" // Hexagon (Cell) with nucleus
    },
  },
  assay_type: {
    'AMPLICON': { 
      color: '#0d9488', // Teal 600
      path: "M17 7l-5-5-5 5M17 17l-5 5-5-5M12 2v20" // Stacked arrows (Repetitive amplification)
    },
    'WGS': { 
      color: '#2563eb', // Blue 600
      path: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z M12 2v20 M2 12h20" // Globe/Grid (Whole Genome coverage)
    },
    'RNA-Seq': { 
      color: '#c026d3', // Fuchsia 600
      path: "M2 10c3 0 3 4 6 4s3-4 6-4 3 4 6 4" // Waveform (Transcriptional expression)
    },
    'OTHER': { 
      color: '#64748b', // Slate 500
      path: "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0 M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0 M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" // Ellipsis (Misc/Other)
    },
    'RAD-Seq': { 
      color: '#d97706', // Amber 600
      path: "M8 3v18M16 3v18M3 12h18" // Fragments/Restriction sites
    },
    'WGA': { 
      color: '#4f46e5', // Indigo 600
      path: "M12 2v20M2 12h20 M12 12l8-8M12 12l-8 8M12 12l8 8M12 12l-8-8" // Expanding star (Whole Genome Amplification)
    },
    'Targeted-Capture': { 
      color: '#e11d48', // Rose 600
      path: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0 M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0 M12 2v4M12 18v4M2 12h4M18 12h4" // Crosshair (Targeted)
    },
    'WXS': { 
      color: '#0284c7', // Sky 600
      path: "M21.21 15.89A10 10 0 1 1 8 2.83M22 12A10 10 0 0 0 12 2v10z" // Pie/Segmented circle (Whole Exome - a slice of the genome)
    },
  },
  platform: {
    // Illumina - Brand Yellow/Orange - Icon: Four dots representing flow cell clusters
    'ILLUMINA': { 
      color: '#f59e0b', 
      path: "M4 4h4v4H4zm12 0h4v4h-4zM4 16h4v4H4zm12 0h4v4h-4z" 
    },
    'ILLUMINA|ILLUMINA': { 
      color: '#d97706', 
      path: "M2 2h5v5H2zm9 0h5v5h-5zm9 0h5v5h-5zM2 11h5v5H2zm9 0h5v5h-5zm9 0h5v5h-5z" // Multi-cluster grid
    },
    'ILLUMINA|ILLUMINA|ILLUMINA': { color: '#b45309', path: "M2 2h5v5H2zm9 0h5v5h-5zm9 0h5v5h-5zM2 11h5v5H2zm9 0h5v5h-5zm9 0h5v5h-5z" },
    'ILLUMINA|ILLUMINA|ILLUMINA|ILLUMINA': { color: '#92400e', path: "M2 2h5v5H2zm9 0h5v5h-5zm9 0h5v5h-5zM2 11h5v5H2zm9 0h5v5h-5zm9 0h5v5h-5z" },

    // PacBio - Green - Icon: Circular ZMW (Zero-Mode Waveguide) sensor
    'PACBIO_SMRT': { 
      color: '#22c55e', 
      path: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 14a4 4 0 1 1 4-4 4 4 0 0 1-4 4z" 
    },

    // Oxford Nanopore - Indigo - Icon: A strand passing through a pore
    'OXFORD_NANOPORE': { 
      color: '#6366f1', 
      path: "M2 12h8m4 0h8M12 8a4 4 0 1 1-4 4 4 4 0 0 1 4-4z" 
    },

    // Ion Torrent - Cyan - Icon: Semiconductor chip
    'ION_TORRENT': { 
      color: '#06b6d4', 
      path: "M6 6h12v12H6zm-4 10h4m12 0h4M10 2v4m4-4v4M10 18v4m4-4v4" 
    },

    // LS454 (Legacy) - Slate - Icon: Honeycomb/Fiber-optic plate
    'LS454': { 
      color: '#94a3b8', 
      path: "M12 2l8.66 5v10L12 21l-8.66-5V8z M12 7l4.33 2.5v5L12 17l-4.33-2.5v-5z" 
    },

    // DNBSEQ (MGI) - Pink - Icon: DNA Nanoball (Concentric spheres)
    'DNBSEQ': { 
      color: '#ec4899', 
      path: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0 M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" 
    },
  },
  instrument: {
    // High-Throughput (Deep Blues/Indigos)
    'Illumina NovaSeq 6000': { 
      color: '#1e3a8a', // Blue 900
      path: "M4 4h16v16H4V4zm0 6h16M4 14h16M8 4v16" // High-capacity rack server look
    },
    'HiSeq X Ten': { 
      color: '#312e81', // Indigo 900
      path: "M4 4h16v16H4V4zm0 5h16M4 10h16M4 15h16" // Multi-unit production icon
    },
    'Illumina HiSeq 4000': { 
      color: '#3730a3', // Indigo 800
      path: "M3 5h18v14H3V5zm0 5h18M3 15h18" 
    },
    'Illumina HiSeq 2500': { 
      color: '#4338ca', // Indigo 700
      path: "M3 5h18v14H3V5zm0 5h18M3 15h18" 
    },
    'Illumina HiSeq 2000': { 
      color: '#4f46e5', // Indigo 600
      path: "M3 5h18v14H3V5zm0 5h18M3 15h18" 
    },

    // Mid-Range & Benchtop (Sky/Cyans)
    'NextSeq 500': { 
      color: '#0284c7', // Sky 600
      path: "M4 6h16v12H4V6zm3 4h2m-2 4h2" // Mid-size benchtop unit
    },
    'NextSeq 550': { 
      color: '#0ea5e9', // Sky 500
      path: "M4 6h16v12H4V6zm3 4h2m-2 4h2" 
    },
    'Illumina MiSeq': { 
      color: '#0891b2', // Cyan 600
      path: "M6 8h12v10H6V8zm3 4h6" // Compact desktop unit
    },

    // Long Read (Green - matching PacBio platform)
    'Sequel II': { 
      color: '#16a34a', // Green 600
      path: "M4 4h16v16H4V4zm8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" // Cabinet with a circular ZMW sensor
    },
  },
};

export const VariableIcon = ({ type, value }) => {
  // Exact match for value or fallback to case-insensitive check
  const config = ICON_MAPPING[type]?.[value] || 
                 ICON_MAPPING[type]?.[Object.keys(ICON_MAPPING[type] || {}).find(k => k.toLowerCase() === String(value).toLowerCase())];

  if (!config) return null;

  return (
    <svg 
      width="16" 
      height="16" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={config.color} 
      strokeWidth="2.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      className="inline-block mr-2 flex-shrink-0 mb-0.5"
    >
      <path d={config.path} />
      {/* Handlers for multi-path icons like "Ocean" or "Viral Sequence" */}
      {value === 'seawater' && <path d="M2 17c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" />}
      {value === 'sea' && <path d="M2 17c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" />}
      {value === 'ocean' && <path d="M2 17c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" />}
      {value === 'Ocean' && <path d="M2 18c1.5 0 2.5 1 4 1s2.5-1 4-1 2.5 1 4 1 2.5-1 4-1" />}
      {value === 'viral sequence' && <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />}
    </svg>
  );
};

export const GEOM_VAR_DESCRIPTIONS = {
  // General
  'GEOM_ID': 'Unique geometry identifier associated to one or several biosamples',
  'GEOMETRY': '2D point well-known text (WKT) geometry format',
  'COORDINATES_PRECISION': 'Estimated scale value assigned to biosample spatial object: i) radius for punctual geometry; ii) length for linear geometry; iii) area for polygon geometry',
  'CHARACTERISTIC_DISTANCE': 'Characteristic distance / scale value associated with the spatial object',
  'DATA_ORIGIN': 'Source database or method origin of the geographic coordinates',
  'DATA_COUNT': 'Total number of sample data records for this geometry',
  'VOU_NUMBER': 'For each unique coordinate, how many biosamples are there ?',
  'VOU_ORIGIN': 'Metagenomic databases names from biosample accession',
  'COORDINATES_ORIGINS': 'Geographic coordinates origins name\n\n - “coordinates parsing” corresponds to the original coordinates.\n- “geoparsing” corresponds to the automatic association between a textual location and a geographic one.',

  // Anthroposphere
  'CONTINENT': 'Continent name',
  'CONTINENT_PERC': 'Continent spatial overlap percentage',
  'COUNTRY': 'Country name',
  'COUNTRY_PERC': 'Country spatial overlap percentage',
  'SUBDIVISION_NAME': 'First administrative subdivision name',
  'SUBDIVISION_TYPE': 'First administrative subdivision type',
  'SUBDIVISION_PERC': 'Administrative subdivision spatial overlap percentage',
  'LAND_COVER_CODE': 'Land cover identifier',
  'LAND_COVER': 'Land cover name',
  'POP_DENS': 'Population density in 2020',
  'LSD_ALL_SPECIES': 'Density livestock of main domestic species',
  'LSD_BFL': 'Buffalo density livestock',
  'LSD_CHK': 'Chicken density livestock',
  'LSD_CTL': 'Cattle density livestock',
  'LSD_GTS': 'Goat density livestock',
  'LSD_PGS': 'Pig density livestock',
  'LSD_SHP': 'Sheep density livestock',

  // Atmosphere
  'ANNUAL_MEAN_TEMPERATURE': 'Annual mean temperature between 1970 and 2000',
  'ANNUAL_PRECIPITATION': 'Annual precipitation between 1970 and 2000',

  // Lithosphere
  'ELEVATION': 'Elevation',

  // Hydrosphere
  'LAND_PERC': 'Percentage of geometry overlapping land area',
  'OCEAN_PERC': 'Percentage of geometry overlapping ocean area',
  'COASTLINE_DISTANCE': 'Nearest coastline distance',
  'Hylak_id': 'Nearest lake identifier',
  'HYLAK_DISTANCE': 'Nearest lake distance',
  'HYRIV_ID': 'Nearest river identifier',
  'HYRIV_DISTANCE': 'Nearest river distance',
  'HYRIV_ID_WWTP': 'Nearest river reach identifier connected to WWTP',
  'WASTE_ID': 'Nearest WWTP (wastewater treatment plant) identifier',
  'WWTP_DISTANCE': 'Nearest WWTP distance',
  'predprob1': 'Predicted probability that river reach ceases to flow for at least one day per year on average somewhere along its length',
  'predcat1': 'Predicted flow intermittence class (based on predprob1)',
  'predprob30': 'Predicted probability that river reach ceases to flow for at least one month (thirty days) per year on average somewhere along its length',
  'predcat30': 'Predicted flow intermittence class (based on predprob30)',
  'PERRENIAL_RIVER': 'Perennial river distinction : if “predprob1” has a probability superior to 0.5, value is 0 (no perennial river), else value is 1 (perennial river)',
  'HYBAS_ID_LEVEL1': 'HydroBASINS Level 1 watershed identifier',
  'HYBAS_ID_LEVEL2': 'HydroBASINS Level 2 watershed identifier',
  'HYBAS_ID_LEVEL3': 'HydroBASINS Level 3 watershed identifier',
  'HYBAS_ID_LEVEL4': 'HydroBASINS Level 4 watershed identifier',
  'HYBAS_ID_LEVEL5': 'HydroBASINS Level 5 watershed identifier',
  'HYBAS_ID_LEVEL6': 'HydroBASINS Level 6 watershed identifier',
  'HYBAS_ID_LEVEL7': 'HydroBASINS Level 7 watershed identifier',
  'HYBAS_ID_LEVEL8': 'HydroBASINS Level 8 watershed identifier',
  'HYBAS_ID_LEVEL9': 'HydroBASINS Level 9 watershed identifier',
  'HYBAS_ID_LEVEL10': 'HydroBASINS Level 10 watershed identifier',
  'HYBAS_ID_LEVEL11': 'HydroBASINS Level 11 watershed identifier',
  'HYBAS_ID_LEVEL12': 'HydroBASINS Level 12 watershed identifier',
  'HYBAS_ID_LEVEL6': 'HydroBASINS Level 6 watershed identifier',
  'HYBAS_ID_LEVEL7': 'HydroBASINS Level 7 watershed identifier',
  'HYBAS_ID_LEVEL8': 'HydroBASINS Level 8 watershed identifier',
  'HYBAS_ID_LEVEL9': 'HydroBASINS Level 9 watershed identifier',
  'HYBAS_ID_LEVEL10': 'HydroBASINS Level 10 watershed identifier',
  'HYBAS_ID_LEVEL11': 'HydroBASINS Level 11 watershed identifier',
  'HYBAS_ID_LEVEL12': 'HydroBASINS Level 12 watershed identifier',
  'WATERSHED_PERC_LEVEL1': 'HydroBASINS Level 1 watershed overlap percentage',
  'WATERSHED_PERC_LEVEL2': 'HydroBASINS Level 2 watershed overlap percentage',
  'WATERSHED_PERC_LEVEL3': 'HydroBASINS Level 3 watershed overlap percentage',
  'WATERSHED_PERC_LEVEL4': 'HydroBASINS Level 4 watershed overlap percentage',
  'WATERSHED_PERC_LEVEL5': 'HydroBASINS Level 5 watershed overlap percentage',
  'WATERSHED_PERC_LEVEL6': 'HydroBASINS Level 6 watershed overlap percentage',
  'WATERSHED_PERC_LEVEL7': 'HydroBASINS Level 7 watershed overlap percentage',
  'WATERSHED_PERC_LEVEL8': 'HydroBASINS Level 8 watershed overlap percentage',
  'WATERSHED_PERC_LEVEL9': 'HydroBASINS Level 9 watershed overlap percentage',
  'WATERSHED_PERC_LEVEL10': 'HydroBASINS Level 10 watershed overlap percentage',
  'WATERSHED_PERC_LEVEL11': 'HydroBASINS Level 11 watershed overlap percentage',
  'WATERSHED_PERC_LEVEL12': 'HydroBASINS Level 12 watershed overlap percentage',

  // Biosphere - IUCN
  'EFG_Code': 'Ecosystem Functional Group identifier (IUCN)',
  'EFG_PERC': 'Ecosystem Functional Group spatial overlap percentage (IUCN)',
  'Biome_Code': 'Biome identifier (IUCN version)',
  'Realm_Code': 'Realm identifier (IUCN version)',

  // Biosphere - WWF / RESOLVE
  'ECO_CODE_WWF': 'Ecoregion identifier (RESOLVE version)',
  'ECO_WWF': 'Ecoregion label (RESOLVE version)',
  'ECO_PERC_WWF': 'Ecoregion spatial overlap percentage (RESOLVE version)',
  'AREA_ECO_WWF': 'Ecoregion area (RESOLVE version)',
  'BIOME_CODE_WWF': 'Biome identifier (RESOLVE version)',
  'BIOME_WWF': 'Biome label (RESOLVE version)',
  'RLM_WWF': 'Realm label (RESOLVE version)',
  'NNH_WWF': 'WWF Ecoregion protection level',

  // Biosphere - MEOW
  'ECO_CODE_MEOW': 'Marine Ecoregion identifier (MEOW version)',
  'ECO_MEOW': 'Marine Ecoregion label (MEOW version)',
  'ECO_PERC_MEOW': 'Marine Ecoregion spatial overlap percentage (MEOW version)',
  'PROV_CODE_MEOW': 'Marine Province identifier (MEOW version)',
  'PROV_MEOW': 'Marine Province label (MEOW version)',
  'RLM_CODE_MEOW': 'Marine Realm identifier (MEOW version)',
  'RLM_MEOW': 'Marine Realm label (MEOW version)',
  'LAT_ZONE_MEOW': 'Latitude climate zone (MEOW version)'
};


export const GEOM_METADATA = {
  // 1: General (Yellow)
  'GEOM_ID': { color: 'bg-yellow-100', link: 'https://ncbi.nlm.nih.gov/biosample' },
  'GEOMETRY': { color: 'bg-yellow-100', link: 'https://ncbi.nlm.nih.gov/biosample' },
  'COORDINATES_PRECISION': { color: 'bg-yellow-100', link: 'https://ncbi.nlm.nih.gov/biosample' },
  'CHARACTERISTIC_DISTANCE': { color: 'bg-yellow-100', link: 'https://ncbi.nlm.nih.gov/biosample' },
  'DATA_ORIGIN': { color: 'bg-yellow-100', link: 'https://ncbi.nlm.nih.gov/biosample' },
  'DATA_COUNT': { color: 'bg-yellow-100', link: 'https://ncbi.nlm.nih.gov/biosample' },
  'VOU_ORIGIN': { color: 'bg-yellow-100', link: 'https://ncbi.nlm.nih.gov/biosample' },
  'VOU_NUMBER': { color: 'bg-yellow-100', link: 'https://ncbi.nlm.nih.gov/biosample' },
  'COORDINATES_ORIGINS': { color: 'bg-yellow-100', link: 'https://ncbi.nlm.nih.gov/biosample' },

  // 2: Anthroposphere (Orange/Peach)
  'CONTINENT': { color: 'bg-orange-100', link: 'https://www.naturalearthdata.com/' },
  'CONTINENT_PERC': { color: 'bg-orange-100', link: 'https://www.naturalearthdata.com/' },
  'COUNTRY': { color: 'bg-orange-100', link: 'https://www.naturalearthdata.com/' },
  'COUNTRY_PERC': { color: 'bg-orange-100', link: 'https://www.naturalearthdata.com/' },
  'SUBDIVISION_NAME': { color: 'bg-orange-100', link: 'https://www.naturalearthdata.com/' },
  'SUBDIVISION_TYPE': { color: 'bg-orange-100', link: 'https://www.naturalearthdata.com/' },
  'SUBDIVISION_PERC': { color: 'bg-orange-100', link: 'https://www.naturalearthdata.com/' },
  'POP_DENS': { color: 'bg-orange-100', link: 'https://doi.org/10.7927/H49C6VHW' },
  'LSD_ALL_SPECIES': { color: 'bg-orange-100', link: 'https://data.apps.fao.org/catalog/iso/e056a913-2a28-454d-ad83-d6ef126bf0ff' },
  'LSD_BFL': { color: 'bg-orange-100', link: 'https://data.apps.fao.org/catalog/iso/e056a913-2a28-454d-ad83-d6ef126bf0ff' },
  'LSD_CHK': { color: 'bg-orange-100', link: 'https://data.apps.fao.org/catalog/iso/e056a913-2a28-454d-ad83-d6ef126bf0ff' },
  'LSD_CTL': { color: 'bg-orange-100', link: 'https://data.apps.fao.org/catalog/iso/e056a913-2a28-454d-ad83-d6ef126bf0ff' },
  'LSD_GTS': { color: 'bg-orange-100', link: 'https://data.apps.fao.org/catalog/iso/e056a913-2a28-454d-ad83-d6ef126bf0ff' },
  'LSD_PGS': { color: 'bg-orange-100', link: 'https://data.apps.fao.org/catalog/iso/e056a913-2a28-454d-ad83-d6ef126bf0ff' },
  'LSD_SHP': { color: 'bg-orange-100', link: 'https://data.apps.fao.org/catalog/iso/e056a913-2a28-454d-ad83-d6ef126bf0ff' },

  // 3: Atmosphere (Green)
  'ANNUAL_MEAN_TEMPERATURE': { color: 'bg-green-100', link: 'https://www.worldclim.org/' },
  'ANNUAL_PRECIPITATION': { color: 'bg-green-100', link: 'https://www.worldclim.org/' },

  // 4: Lithosphere (Purple)
  'ELEVATION': { color: 'bg-purple-100', link: 'https://www.worldclim.org/' },

  // 5: Hydrosphere (Cyan)
  'LAND_PERC': { color: 'bg-cyan-100', link: 'https://www.naturalearthdata.com/' },
  'OCEAN_PERC': { color: 'bg-cyan-100', link: 'https://www.naturalearthdata.com/' },
  'COASTLINE_DISTANCE': { color: 'bg-cyan-100', link: 'https://www.naturalearthdata.com/' },
  'Hylak_id': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrolakes' },
  'HYLAK_DISTANCE': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrolakes' },
  'HYRIV_ID': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrorivers' },
  'HYRIV_DISTANCE': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrorivers' },
  'HYRIV_ID_WWTP': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrowaste' },
  'WASTE_ID': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrowaste' },
  'WWTP_DISTANCE': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrowaste' },
  'predprob1': { color: 'bg-cyan-100', link: 'https://doi.org/10.6084/m9.figshare.14633022' },
  'predcat1': { color: 'bg-cyan-100', link: 'https://doi.org/10.6084/m9.figshare.14633022' },
  'predprob30': { color: 'bg-cyan-100', link: 'https://doi.org/10.6084/m9.figshare.14633022' },
  'predcat30': { color: 'bg-cyan-100', link: 'https://doi.org/10.6084/m9.figshare.14633022' },
  'PERRENIAL_RIVER': { color: 'bg-cyan-100', link: 'https://doi.org/10.6084/m9.figshare.14633022' },
  'HYBAS_ID_LEVEL1': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'HYBAS_ID_LEVEL2': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'HYBAS_ID_LEVEL3': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'HYBAS_ID_LEVEL4': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'HYBAS_ID_LEVEL5': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'HYBAS_ID_LEVEL6': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'HYBAS_ID_LEVEL7': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'HYBAS_ID_LEVEL8': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'HYBAS_ID_LEVEL9': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'HYBAS_ID_LEVEL10': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'HYBAS_ID_LEVEL11': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'HYBAS_ID_LEVEL12': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'WATERSHED_PERC_LEVEL1': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'WATERSHED_PERC_LEVEL2': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'WATERSHED_PERC_LEVEL3': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'WATERSHED_PERC_LEVEL4': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'WATERSHED_PERC_LEVEL5': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'WATERSHED_PERC_LEVEL6': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'WATERSHED_PERC_LEVEL7': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'WATERSHED_PERC_LEVEL8': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'WATERSHED_PERC_LEVEL9': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'WATERSHED_PERC_LEVEL10': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'WATERSHED_PERC_LEVEL11': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },
  'WATERSHED_PERC_LEVEL12': { color: 'bg-cyan-100', link: 'https://www.hydrosheds.org/products/hydrobasins' },

  // 6: Biosphere (Pink)
  'EFG_Code': { color: 'bg-pink-100', link: 'https://zenodo.org/records/10081251' },
  'EFG_PERC': { color: 'bg-pink-100', link: 'https://zenodo.org/records/10081251' },
  'Biome_Code': { color: 'bg-pink-100', link: 'https://zenodo.org/records/10081251' },
  'Realm_Code': { color: 'bg-pink-100', link: 'https://zenodo.org/records/10081251' },
  'ECO_CODE_WWF': { color: 'bg-pink-100', link: 'https://ecoregions.world/' },
  'ECO_WWF': { color: 'bg-pink-100', link: 'https://ecoregions.world/' },
  'ECO_PERC_WWF': { color: 'bg-pink-100', link: 'https://ecoregions.world/' },
  'BIOME_CODE_WWF': { color: 'bg-pink-100', link: 'https://ecoregions.world/' },
  'BIOME_WWF': { color: 'bg-pink-100', link: 'https://ecoregions.world/' },
  'AREA_ECO_WWF': { color: 'bg-pink-100', link: 'https://ecoregions.world/' },
  'RLM_WWF': { color: 'bg-pink-100', link: 'https://ecoregions.world/' },
  'NNH_WWF': { color: 'bg-pink-100', link: 'https://resourcewatch.org/data/explore/Marine-Ecoregions' },
  'ECO_CODE_MEOW': { color: 'bg-pink-100', link: 'https://resourcewatch.org/data/explore/Marine-Ecoregions' },
  'ECO_MEOW': { color: 'bg-pink-100', link: 'https://resourcewatch.org/data/explore/Marine-Ecoregions' },
  'ECO_PERC_MEOW': { color: 'bg-pink-100', link: 'https://resourcewatch.org/data/explore/Marine-Ecoregions' },
  'PROV_CODE_MEOW': { color: 'bg-pink-100', link: 'https://resourcewatch.org/data/explore/Marine-Ecoregions' },
  'PROV_MEOW': { color: 'bg-pink-100', link: 'https://resourcewatch.org/data/explore/Marine-Ecoregions' },
  'RLM_CODE_MEOW': { color: 'bg-pink-100', link: 'https://resourcewatch.org/data/explore/Marine-Ecoregions' },
  'RLM_MEOW': { color: 'bg-pink-100', link: 'https://resourcewatch.org/data/explore/Marine-Ecoregions' },
  'LAT_ZONE_MEOW': { color: 'bg-pink-100', link: 'https://resourcewatch.org/data/explore/Marine-Ecoregions' },
};
